import React from 'react'

import Botao from '../../../../Mantine/Botao/index.jsx'
import Group from '../../../../Mantine/Group/index.jsx'
import Modal from '../../../../Mantine/Modal/index.jsx'

import * as S from './styles.js'

export default function AlertaParqueTodo({ onClick, opened }) {
  return (
    <div>
      <Modal
        titulo="Atenção!"
        width="600px"
        type="alerta"
        opened={opened}
        positionTitle="center"
      >
        <S.ModalAlert>
          <p className="modal-alert">
            Prezado cliente, essa ação só poderá ser executada com no máximo 50
            linhas selecionadas.
          </p>
          <Group position="center">
            <Botao label="Fechar" variant="outline" onClick={onClick} />
          </Group>
        </S.ModalAlert>
      </Modal>
    </div>
  )
}
